export default "__VITE_ASSET__zryf7Jdu__"